import { useTranslation } from 'react-i18next';

import { useLeague } from '@/feature/league-hub-sbk/hooks/use-league';

import { useLeagueSport } from '../../hooks/use-league-sport';
import {
    EVENT_LIST_PAGE_SIZE,
    useLeagueTraditionalMatchupDataWithMarkets,
} from '../../hooks/use-league-traditional-matchup-data';
import { EventList } from '../EventList';
import { NoMarketsMessage } from '../NoMarketsMessage';
import { LeagueSectionTitle } from './LeagueSectionTitle';
import { LobbyEventsTray } from './LobbyEventsTray';

type LobbyEventsSectionProps = {
    leagueId: string | undefined;
};

export const LobbyEventsSection = ({ leagueId }: LobbyEventsSectionProps) => {
    // a sport or competition entry with no sub-groups has no league to query
    if (!leagueId) {
        return <EmptyEvents />;
    }
    return <LeagueEventsSection leagueId={leagueId} />;
};

const EmptyEvents = () => {
    const { t } = useTranslation('lobby_sbk');
    return <NoMarketsMessage message={t('markets_available_soon')} />;
};

const LeagueEventsSection = ({ leagueId }: { leagueId: string }) => {
    const { data: league } = useLeague(leagueId);
    const sport = useLeagueSport(leagueId);
    const matchupData = useLeagueTraditionalMatchupDataWithMarkets({
        leagueId,
        limit: EVENT_LIST_PAGE_SIZE,
        isLive: false,
    });

    const isEmpty = league?.event_count === 0 || (!matchupData.isLoading && !matchupData.hasAnyAvailableMarkets);
    if (isEmpty) {
        return <EmptyEvents />;
    }

    return (
        <>
            <LobbyEventsTray leagueId={leagueId} header={<LeagueSectionTitle sport={sport} section="events" />} />
            <EventList
                leagueId={leagueId}
                matchupData={matchupData}
                header={<LeagueSectionTitle sport={sport} section="lines" />}
            />
        </>
    );
};
